/* CDB Commerce — shared cart quantity engine
   Used by Home, Collection and any page that renders CDB quantity controls. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const busy = new Map();

  const clampQuantity = (value, input = null) => {
    let qty = Number.parseInt(value, 10);
    if (!Number.isFinite(qty)) qty = 0;
    const min = Number.parseInt(input?.getAttribute('min') || '0', 10) || 0;
    const maxRaw = input?.getAttribute('max');
    const max = maxRaw ? Number.parseInt(maxRaw, 10) : Number.POSITIVE_INFINITY;
    const step = Number.parseInt(input?.getAttribute('step') || '1', 10) || 1;
    qty = Math.max(min, Math.min(max, qty));
    if (step > 1) qty = Math.round(qty / step) * step;
    return Math.max(0, qty);
  };

  const getCart = async () => {
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Không thể tải giỏ hàng.');
    return response.json();
  };

  const updateBadges = (cart) => {
    const count = Number(cart?.item_count || 0);
    document.querySelectorAll('[data-cdb-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      bubble.classList.toggle('hidden', count < 1);
      bubble.querySelectorAll('span').forEach((span, index) => {
        if (index === 0 || span.getAttribute('aria-hidden') === 'true') span.textContent = String(count);
      });
    });
  };

  const syncQuantityInputs = (cart) => {
    const byVariant = new Map((cart?.items || []).map((item) => [Number(item.variant_id), Number(item.quantity)]));

    document.querySelectorAll('[data-cdb-qty][data-variant-id]').forEach((control) => {
      const id = Number(control.dataset.variantId);
      const item = (cart?.items || []).find((line) => Number(line.variant_id) === id);
      const input = control.querySelector('[data-cdb-qty-input]');
      if (input && document.activeElement !== input) input.value = String(byVariant.get(id) || 0);
      control.dataset.lineKey = item?.key || '';
    });

    document.querySelectorAll('[data-cdb-shared-qty][data-quantity-variant-id]').forEach((input) => {
      const id = Number(input.dataset.quantityVariantId);
      if (document.activeElement !== input) input.value = String(byVariant.get(id) || 0);
      input.dataset.cartQuantity = String(byVariant.get(id) || 0);
    });
  };

  

const broadcast = (cart) => {
  updateBadges(cart);
  syncQuantityInputs(cart);
  document.dispatchEvent(new CustomEvent('cdb:cart-updated', { detail: { cart } }));
  document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart } }));

  if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
      source: 'cdb-shared-quantity',
      cartData: cart
    });
  }

};

  const setVariantQuantity = async (variantId, requestedQuantity, input = null) => {
    const id = Number(variantId);
    if (!id || busy.get(id)) return getCart();
    const quantity = clampQuantity(requestedQuantity, input);
    busy.set(id, true);
    if (input) {
      input.value = String(quantity);
      input.setAttribute('aria-busy', 'true');
    }

    try {
      const current = await getCart();
      const line = current.items.find((item) => Number(item.variant_id) === id);
      let response;

      if (line) {
        response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity }),
        });
      } else if (quantity > 0) {
        response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] }),
        });
      }

      if (response && !response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || 'Không thể cập nhật giỏ hàng.');
      }

      const cart = await getCart();
      broadcast(cart);

      if (window.location.pathname === '/cart') {
        window.location.reload();
      }

      return cart;
    } catch (error) {
      console.error('[CDB Cart]', error);
      const cart = await getCart().catch(() => null);
      if (cart) broadcast(cart);
      window.alert(error.message || 'Không thể cập nhật giỏ hàng. Vui lòng thử lại.');
      throw error;
    } finally {
      busy.delete(id);
      if (input) input.removeAttribute('aria-busy');
    }
  };

  const sharedInput = (target) => target?.closest?.('[data-cdb-shared-qty][data-quantity-variant-id]');

  document.addEventListener('input', (event) => {
    const input = sharedInput(event.target);
    if (!input) return;
    input.value = input.value.replace(/[^0-9]/g, '');
  }, true);

  document.addEventListener('keydown', (event) => {
    const input = sharedInput(event.target);
    if (!input || event.key !== 'Enter') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    setVariantQuantity(input.dataset.quantityVariantId, input.value, input)
      .finally(() => input.blur());
  }, true);

  document.addEventListener('change', (event) => {
    const input = sharedInput(event.target);
    if (!input) return;
    event.stopImmediatePropagation();
    setVariantQuantity(input.dataset.quantityVariantId, input.value, input)
      .finally(() => input.blur());
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.cdb-commerce-quantity .quantity__button');
    if (!button) return;
    const control = button.closest('.cdb-commerce-quantity');
    const input = control?.querySelector('[data-cdb-shared-qty][data-quantity-variant-id]');
    if (!input) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const delta = button.name === 'minus' ? -1 : 1;
    const next = clampQuantity((Number.parseInt(input.value, 10) || 0) + delta, input);
    setVariantQuantity(input.dataset.quantityVariantId, next, input);
  }, true);

  window.CDBCart = {
  getCart,
  setVariantQuantity,

  // Chỉ đồng bộ UI từ cart data có sẵn.
  // Không fetch, không publish event -> tránh loop.
  syncUI: (cart) => {
    updateBadges(cart);
    syncQuantityInputs(cart);
  },

  sync: async () => {
    const cart = await getCart();
    broadcast(cart);
    return cart;
  },
};

  document.addEventListener('DOMContentLoaded', () => window.CDBCart.sync().catch(console.error));
})();
